import OnboardingFooter from 'Components/onboardingRevamp/OnboardingFooter';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Logo from 'Components/layout/assets/Logo';
import {
  maxWidth,
  primaryColor, primaryHeadingColor, retina,
  scrollbar, secondaryFont, wLight, wMBold,
  wMedium, maxWidth1300, minWidthApp,
  midTablet, smMobile,
  maxMobile,
  maxTablet,
  midMobile,
  smMobile400,
} from 'Utils/utilsStyle';
import ConfirmProfileComponent from 'Components/onboardingRevamp/ConfirmProfileComponent';
import FollowCompanyComponent from 'Components/onboardingRevamp/FollowCompanyComponent';
import { useDispatch, useSelector } from 'react-redux';
import { setOnBoardingSlide } from 'Selector/UISelector';
import FollowPeopleComponent from 'Components/onboardingRevamp/FollowPeopleComponent';
import {
  IsMobile,
  getCurrentTime,
  getLangCookie, setLocalStorageValue, skipOnboarding, valueToObject,
} from 'Utils/UtilityFunctions';
import { useNavigate } from 'react-router-dom';
import { selectFollowedCompaniesCount } from 'Selector/OnboardingSelector';
import { actions as flurryActions } from 'Slice/HelperSlice';
import {
  CONGRATS_SCREEN_FIRST_TEXT, CONGRATS_SCREEN_LAST_TEXT,
  WELCOME_SCREEN_FIRST_TEXT, WELCOME_SCREEN_LAST_TEXT,
} from 'Utils/Constants';

import OnboardingGilroyFirework from 'Components/common/assets/svgIcons/OnboardingGilroyFirework';
import { selectPage } from 'Selector/ProfileConfirmationSelector';
import ToasterNotification from 'Components/common/components/ToasterNotification';
import { notificationMessage } from 'Selector/HelperSelector';
import WelcomeScreen from './WelcomeScreen';

import { actions } from '../../Slice/OnboardingSlice';
import { actions as profileConfirmationActions } from '../../Slice/ProfileConfirmationSlice';
import { actions as companiesActions } from '../../Slice/CompaniesSlice';

const StyleWrapper = styled.div<{ containerHeight: number }>`
display: flex;
flex-direction: column;
align-items: center;
background-color: #fff;
height: 100vh;
padding-top: 83px;
@media all and (max-width: ${maxWidth}), ${retina} {
  padding-top: 70px;
}
.logo-div-onboarding {
  display: flex;
  align-items: center;
  .logo-xiq {
    width: 54px;
    height: 28px;
    margin-right: 10px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      width: 41px;
      height: 25px;
      margin-left: 6px;
    }
  }
  .welcome-text {
    color: ${primaryHeadingColor};
    font-family: ${secondaryFont};
    font-size: 34px;
    font-weight: ${wMedium};
    line-height: 40px;
    letter-spacing: -0.848px;
    margin-right: 10px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 27px;
      line-height: 34px;
      margin-right: 4px;
    }
    @media all and (max-width: ${maxTablet}) {
      font-size: 26px;
      line-height: 32px;
    }
  }
  .title-onboarding-app {
    color: ${primaryColor};
    font-family: ${secondaryFont};
    font-size: 36px;
    font-weight: ${wMBold};
    letter-spacing: -0.911px;
    margin-bottom: 0px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 28px;
    }
    @media all and (max-width: ${maxTablet}) {
      font-size: 27px;
    }
    @media all and (max-width: ${maxMobile}) {
      font-size: 26px;
    }
    sup {
      font-size: 15px;
      top: -15px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        font-size: 12px;
        top: -13px;
      }
      @media all and (max-width: ${maxMobile}) {
        font-size: 10px;
        top: -13px;
      }
    }
  }
}
.title-search-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .title-for-module {
    color: ${primaryHeadingColor};
    text-align: center;
    font-family: ${secondaryFont};
    font-size: 26px;
    font-weight: ${wMedium};
    line-height: 35px;
    letter-spacing: -0.75px;
    margin-top: 32px;
    margin-bottom: 10px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 22px;
      margin-top: 4px;
      margin-bottom: 8px;
    }
    @media all and (max-width: ${maxTablet}) {
      font-size: 16px;
    }
    
  }
  .search-wrapper {
    .ant-input-affix-wrapper {
      width: 600px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        width: 560px;
        height: 38px;
      }
      @media all and (max-width: ${maxTablet}) {
        width: 363px;
      }
      @media all and (max-width: ${maxMobile}) {
        width: 327px;
        padding-right: 30px;
      }
      .ant-input-prefix {
        margin-right: 8px;
        padding-right: 4px;
        border-right: 1px solid rgb(218, 218, 218);
        @media all and (max-width: ${maxMobile}) {
          padding-right: 2px;
        }
        .search-global-icon-svg {
          @media all and (max-width: ${maxMobile}) {
            height: 16px;
            margin-left: -2px;
          }
        }
      }
      .ant-input {
        @media all and (max-width: ${maxMobile}) {
          font-size: 14px;
        }
      }
      input::placeholder {
        font-weight: ${wLight};
      }
    }
    .cross-icon {
      top: 13px;
      right: 10px;
    }
  }
}
.onboarding-component-mapping-container {
  width: 100%;
  height: ${(props) => `calc(100% - (${props.containerHeight}px))`};
  padding: 0px 50px 0px 82px;
  @media all and (max-width: ${maxWidth}), ${retina} {
    padding: 0px 50px 0px 80px;
    height: ${(props) => `calc(100% - (${props.containerHeight}px))`};
  }
  @media all and (max-width: ${maxWidth1300}) {
    padding: 0 20px 0px 40px;
  }
  @media all and (max-width: ${minWidthApp}) {
    padding: 0 10px 0px 20px;
  }
  @media all and (max-width: ${maxMobile}) {
    padding: 0 10px;
  }
  .title-heading {
    color: ${primaryHeadingColor};
    font-family: ${secondaryFont};
    font-size: 24px;
    font-weight: ${wMedium};
    line-height: 47px;
    letter-spacing: -0.7px;
    margin-top: 43px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 20px;
      line-height: normal;
      margin-top: 2px;
    }
    @media all and (max-width: ${maxTablet}) {
      font-size: 18px;
      margin-top: 12px;
    }
    @media all and (max-width: ${maxMobile}) {
      font-size: 16px;
    }
    @media all and (max-width: ${smMobile400}) {
      margin-left: 13px;
    }
  }
  .scroll-wrapper-onboarding-company {
    &.emptyState {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    max-height: calc(100% - 219px);
    ${scrollbar};
    @media all and (max-width: ${maxWidth}), ${retina} {
      max-height: calc(100% - 142px);
    }
    .infinite-scroll-component__outerdiv {
      height: unset;
      .infinite-scroll-component-onboarding {
        overflow: hidden !important;
      }
    }
  }
  .onboarding-component-wrap {
    &.company-wrap {
      @media all and (max-width: ${smMobile400}) {
        gap: 16px 0px;
      }
    }
    &.emptyWrap {
      height: calc(100% - 150px);
      justify-content: center;
    }
    display: flex;
    flex-flow: wrap;
    width: 100%;
    gap: 16px 0px;
    @media all and (max-width: ${smMobile400}) {
      gap: 16px 16px;
    }
    .person-skeleton-loader {
      margin-right: 15px;
    }
    .component-card {
      &.company-card-flex {
        display: flex;
        justify-content: center; 
        padding: 0px;
      }
      &.follow-company {
        @media all and (max-width: ${minWidthApp}) {
          max-width: calc(100% / 5);
          flex: 1 1 calc(100% / 5);
        }
        @media all and (max-width: ${midTablet}) {
          max-width: calc(100% / 4);
          flex: 1 1 calc(100% / 4);
        }
        @media all and (max-width: ${midMobile}) {
          max-width: calc(100% / 3);
          flex: 1 1 calc(100% / 3);
        }  
      }
      height: fit-content;
      flex: 1 1 calc(100% / 7);
      max-width: calc(100% / 7);
      margin-bottom: 18px;
      padding: 0 10px;
      @media all and (max-width: ${maxWidth1300}) {
        max-width: calc(100% / 6);
        flex: 1 1 calc(100% / 6);
      }
      @media all and (max-width: ${midTablet}) {
        max-width: calc(100% / 5);
        flex: 1 1 calc(100% / 5);
      }
      @media all and (max-width: ${midMobile}) {
        max-width: calc(100% / 4);
        flex: 1 1 calc(100% / 4);
      }
      @media all and (max-width: ${smMobile}) {
        max-width: calc(100% / 3);
        flex: 1 1 calc(100% / 3);
      }
      @media all and (max-width: ${smMobile400}) {
        padding: 0px 5px;
        max-width: 103px;
        flex: 1 1 103px;
      }
    }
  }
}
`;

const Onboarding = function Onboarding() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [activeIndex, setActiveIndex] = useState<number>(-1);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [prevSearch, setPrevSearch] = useState<string>('');
  // const [searchedCompany, setSearchedCompany] = useState<string>('');
  // const [searchedPeople, setSearchedPeople] = useState<string>('');
  const [containerHeight, setContainerHeight] = useState<number>(0);
  const scrollDivRef = useRef<HTMLDivElement>(null);
  const isMob = IsMobile();
  const onBoardingSlide = useSelector(setOnBoardingSlide);
  const followedCompaniesCount = useSelector(selectFollowedCompaniesCount);
  const searchPage = useSelector(selectPage);
  const toasterMessage = useSelector(notificationMessage);
  const host = window.location.href;
  const startTime = getCurrentTime();

  useEffect(() => {
    if (!searchQuery) return;
    setPrevSearch(searchQuery);
  }, [searchQuery]);

  useEffect(() => {
    if (skipOnboarding()) navigate('/feed');
    dispatch(actions.getUserOnboardingData({}));

    return () => {
      dispatch(actions.resetOnboardingComplete({}));
      dispatch(companiesActions.reset());
    };
  }, [dispatch, navigate]);

  useEffect(() => {
    if (followedCompaniesCount > 2) {
      setLocalStorageValue('skipOnBoarding', '1');
      navigate('/feed');
    }
  }, [followedCompaniesCount, navigate]);

  const updateContainerHeight = () => {
    const logoElement = document.getElementById('xiq-logo-div');
    const footerElement = document.getElementById('onboarding-revamp-footer-id');
    const logoHeight = logoElement?.clientHeight || 0;
    const footerHeight = footerElement?.clientHeight || 0;
    const totalHeight = logoHeight + footerHeight;
    setContainerHeight(totalHeight);
  };

  useEffect(() => {
    updateContainerHeight();
    window.addEventListener('resize', updateContainerHeight);
    return () => {
      window.removeEventListener('resize', updateContainerHeight);
    };
  }, []);
  const refineQuery = (line: string) => line.trim().replace(/\s+/g, ' ');

  const onSearching = (searchTerm: string) => {
    if (searchTerm.trim().length) {
      scrollDivRef.current?.scrollTo({ top: 0 });
      setSearchQuery(refineQuery(searchTerm));
      if (refineQuery(searchTerm) === searchQuery) return;
      if (onBoardingSlide === 1) {
        dispatch(profileConfirmationActions.getSearchPeople({
          query: `person:${searchTerm}`,
          screenName: 'onboardingSearchProfile',
          page: 1,
          defaultLanguage: getLangCookie(),
        }));
      }
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('profile_mapping_search', 0, { searchTerm, page: 1 }),
      ));
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('search_Enter_ConfirmProfile_Onboarding', startTime, {
          host,
        }),
      ));
      setActiveIndex(-1);
    } else {
      setSearchQuery('');
    }
  };

  const formatQuery = (line: string) => {
    let query = line;
    if (!query.startsWith('person:')) {
      query = `person: ${query}`;
    }
    return query;
  };

  const fetchMore = () => {
    const res = !searchQuery ? formatQuery(refineQuery(prevSearch))
      : formatQuery(refineQuery(searchQuery));

    dispatch(profileConfirmationActions.getSearchPeople({
      query: res,
      page: searchPage,
      screenName: 'onboardingSearchProfile',
      defaultLanguage: getLangCookie(),
    }));

    dispatch(flurryActions.callFlurryEvent(
      valueToObject('profile_mapping_search', 0, { searchQuery, page: searchPage }),
    ));
  };

  const conditionalRendering = (slideNumber: number) => {
    switch (slideNumber) {
      case 0:
        return (
          <WelcomeScreen
            firstText={WELCOME_SCREEN_FIRST_TEXT}
            lastText={WELCOME_SCREEN_LAST_TEXT}
          />
        );
      case 1:
        return (
          <ConfirmProfileComponent
            setSearchQuery={setSearchQuery}
            activeIndex={activeIndex}
            searchTerm={searchQuery}
            onSearching={onSearching}
            setActiveIndex={setActiveIndex}
            fetchMore={fetchMore}
            scrollDivPersonRef={scrollDivRef}
          />
        );
      case 2:
        return (
          <FollowCompanyComponent
            activeIndex={activeIndex}
          // queryData={searchedCompany}
          // setQueryData={setSearchedCompany}
          />
        );
      case 3:
        return (
          <FollowPeopleComponent
            activeIndex={activeIndex}
          // queryData={searchedPeople}
          // setQueryData={setSearchedPeople}
          />
        );
      case 4:
        return (
          <WelcomeScreen
            firstText={CONGRATS_SCREEN_FIRST_TEXT}
            lastText={CONGRATS_SCREEN_LAST_TEXT}
            emoji={<OnboardingGilroyFirework />}
          />
        );
      default:
        return <WelcomeScreen />;
    }
  };

  return (
    <>
      {toasterMessage ? (
        <ToasterNotification />
      ) : null}
      <StyleWrapper containerHeight={containerHeight}>
        <div className="logo-div-onboarding" id="xiq-logo-div">
          {onBoardingSlide === 0 && !isMob ? (
            <span className="welcome-text">Welcome to</span>
          ) : null}
          <Logo />
          <h1 className="title-onboarding-app">
            Sales Xelerator
            <sup>TM</sup>
          </h1>
        </div>
        {conditionalRendering(onBoardingSlide)}
        <OnboardingFooter activeIndex={activeIndex} />
      </StyleWrapper>
    </>
  );
};

export default Onboarding;
